<div class="eui-block-content__wrapper" aria-label="eUI Block Content wrapper">
    <ng-content></ng-content>
</div>
